import type { HttpClient } from '../core/http.js';
import type { Page, RequestOptions } from '../types/common.js';
import type {
  ListWebhookHistoriesParams,
  WebhookHistory,
} from '../types/webhook.js';

/** Inspect and replay webhook deliveries. Scope: `webhooks:manage`. */
export class WebhookHistoriesResource {
  constructor(private readonly http: HttpClient) {}

  list(
    params: ListWebhookHistoriesParams = {},
    options: RequestOptions = {},
  ): Promise<Page<WebhookHistory>> {
    return this.http.requestList<WebhookHistory>('GET', '/webhook-histories', {
      ...options,
      query: params as Record<string, unknown>,
    });
  }

  retrieve(id: string, options: RequestOptions = {}): Promise<WebhookHistory> {
    return this.http.request<WebhookHistory>(
      'GET',
      `/webhook-histories/${encodeURIComponent(id)}`,
      options,
    );
  }

  /** Re-enqueue a failed delivery. */
  retry(id: string, options: RequestOptions = {}): Promise<WebhookHistory> {
    return this.http.request<WebhookHistory>(
      'POST',
      `/webhook-histories/${encodeURIComponent(id)}/retry`,
      options,
    );
  }
}
